import { trim } from "@/services/UtilitiesService";
import { md5 } from "js-md5";
import { StatusedClass } from "./StatusedClass";
import { UploadStatus } from "./UploadStatus";
import { ExistsCheck } from "./ExistsCheck";

export class Upload extends StatusedClass {
  public path = "";
  public name = "";
  public file: Blob | null = null;
  public existsCheck: ExistsCheck = new ExistsCheck();
  public brand = "";
  public caseReference = "";
  public reason = "";
  public get filename(): string {
    return this.existsCheck.status === UploadStatus.Success
      ? this.existsCheck.exists
        ? this.existsCheck.overwrite
          ? this.name
          : (this.existsCheck.newFileName || this.existsCheck.suggestedFileName).split("/").reverse()[0]
        : this.name
      : this.name;
  }
  public get fullFileName() {
    return trim(`${this.path}/${this.filename}`, "/");
  }
  public get fileReference(): string {
    if (this.existsCheck?.overwrite) {
      return this.existsCheck.fileReference;
    }
    return md5(`${this.brand}/${this.caseReference}/${this.fullFileName}`.replace("//", "/"));
  }
  constructor(
    brand: string,
    caseReference: string,
    path: string,
    name: string,
    file: Blob,
    status: UploadStatus = UploadStatus.Waiting,
    reason = "",
  ) {
    super();
    this.brand = brand;
    this.caseReference = caseReference;
    this.path = path;
    this.name = name;
    this.file = file;
    this.status = status;
    this.reason = reason;
  }
}

export interface FileExistsRequest {
  fileName: string;
}

export interface FileExistsResponse {
  suggestedFileName: string;
  fileReference: string;
}
